/* Purpose: All clients mapped out into cards with Client Name, email and view data button
 * Props: allClients (map)
 *         handleViewData (func)
 * Author: R. Markowitz (May 2025)
 * Dev Notes: 
*/

import React , {useEffect} from "react";
import SubmitButton from './Button';
import { Row, Card, Col, Badge, Stack } from 'react-bootstrap';

const AdminClients = ({allClients, handleViewData}) => {
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    },[])
    
    return (
        <Row xs={1} md={3} className="g-4 m-5"> 
            {allClients && (
                <>
            {allClients.map((client, index) =>{return (
                <Col className='d-flex col-sm'>
                    <Card key = {index} className = "p-2 flex-fill border-10">
                        <Card.Title>
                            <Stack direction = "horizontal" gap = {2}>
                                <>{client.Personal['First Name'] + " " + client.Personal['Last Name']}</>
                                <>{client.newLoans > 0 && (<Badge className = 'ms-auto' pill bg="danger">{client.newLoans} New Loan{client.newLoans > 1 && ("s")}</Badge>)}</>

                            </Stack>
                        </Card.Title>
                        <p>Email: {client.Personal['Email']}</p>
                        <div className="text-align-center mt-auto w-100"><SubmitButton className = "" text = "View Data" onClick = {() => handleViewData(client)} width = "90"/></div>
                    </Card>
                </Col>
            )})}
            </>)}
        </Row>  
    )
};

export default AdminClients;